/**
 * services/similarity-detector.service.ts
 *
 * @version: 16/05/2026_1c (registrada entidad 'technology')
 */
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SystemService, CheckSimilarResponse, SimilarityMatch } from './systems.service';
import { TechnologyService } from './technology.service'; // NUEVO 1c

export { SimilarityMatch, CheckSimilarResponse };

type CheckSimilarFn = (name: string, excludeId?: string | null) => Observable<CheckSimilarResponse>;

@Injectable({
  providedIn: 'root'
})
export class SimilarityDetectorService {

  private registry: Map<string, CheckSimilarFn> = new Map();

  constructor(
    private systemService: SystemService,
    private technologyService: TechnologyService // NUEVO 1c
  ) {
    this.registry.set('system', (n, e) => this.systemService.checkSimilar(n, e));
    // NUEVO 1c
    this.registry.set('technology', (n, e) => this.technologyService.checkSimilar(n, e));
  }

  check(entityName: string, name: string, excludeId?: string | null): Observable<CheckSimilarResponse> {
    const fn = this.registry.get(entityName);
    if (!fn) return of({ similar: [] });
    return fn(name, excludeId);
  }

  isRegistered(entityName: string): boolean {
    return this.registry.has(entityName);
  }
}